import './App.css';
import { ChatRequestForm } from './components/ChatRequestForm';
import { VwImport } from './components/VwImport';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from './auth/Auth0ProviderWithNavigate';
import { PrivateRoute } from './components/PrivateRoute';
import MainMenu from './components/MainMenu';
import { ConfigForm } from './components/ConfigForm';
import { PdfAnonymizerForm } from './components/PdfAnonymizerForm';
import { PdfSplitterForm } from './components/PdfSplitterForm';
import { PdfRenamerForm } from './components/PdfRenamerForm';
import { PdfSharingForm } from './components/PdfSharingForm';
import { PdfFolderSharingForm } from './components/PdfFolderSharingForm';
import { PdfImageExtractorForm } from './components/PdfImageExtractorForm';
import { PdfReaderForm } from './components/PdfReaderForm';
import { PdfDownloaderForm } from './components/PdfDownloaderForm';
import QueueForm from './components/QueueForm';
import SessionsForm from './components/SessionsForm';
import { useParams } from 'react-router-dom';
import { PdfRebrandingForm } from './components/PdfRebrandingForm';
import VinListEnrichmentForm from './components/VinListEnrichmentForm';
import VinInspectionGrid from './components/VinInspectionGrid';
import DashboardPage from './components/DashboardPage';
import VinViewDashboardPage from './components/VinViewDashboardPage';
import UploadReviewForm from './components/UploadReviewForm';
import ReviewComparisonPage from './components/ReviewComparisonPage';
import VinDecoderForm from './components/VinDecoderForm';

function ConfigFormWithSession() {
  const { sessionId } = useParams();
  return <ConfigForm savedSessionId={sessionId} />;
}

// Read params and pass to the grid
function VinInspectionGridWithParams() {
  const { sessionId, vin, nav } = useParams();
  return <VinInspectionGrid vin={vin} sessionId={sessionId} type="full" nav={nav} />;
}

function App() {

  return (
    <PrimeReactProvider>
      <Router>
        <Auth0ProviderWithNavigate>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <SessionsForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/config"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <ConfigForm />
                </PrivateRoute>
              }
            />            
            <Route
              path="/chat"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <ChatRequestForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/vin-list"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <VinListEnrichmentForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/config/:sessionId"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <ConfigFormWithSession />
                </PrivateRoute>
              }
            />
            <Route
              path="/queue-partslink"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <QueueForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/queue-myrenault"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <QueueForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pdf-anonymizer"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfAnonymizerForm />
                </PrivateRoute>
              }
            />            
            <Route
              path="/pdf-splitter"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfSplitterForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pdf-renamer"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfRenamerForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pdf-sharing"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfSharingForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pdf-folder-sharing"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfFolderSharingForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pdf-image-extractor"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfImageExtractorForm />
                </PrivateRoute>
              }
            />            
            <Route
              path="/pdf-reader"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfReaderForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pdf-downloader"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfDownloaderForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/pdf-rebranding"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <PdfRebrandingForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/import"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <VwImport />
                </PrivateRoute>
              }
            />
            <Route
              path="/sessions"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <SessionsForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <DashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/vin-dashboard"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <VinViewDashboardPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/review/:sessionId"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <UploadReviewForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/inspect/:sessionId/:nav/:vin"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <VinInspectionGridWithParams />
                </PrivateRoute>
              }
            />
            <Route
              path="/review-compare/:reviewSessionId"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <ReviewComparisonPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/decoder"
              element={
                <PrivateRoute>
                  <MainMenu />
                  <VinDecoderForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/decoder-lite"
              element={
                <VinDecoderForm lite />
              }
            />
          </Routes>
        </Auth0ProviderWithNavigate>
      </Router>
    </PrimeReactProvider>
  );
}

export default App;